import moment from 'moment';
import { FC } from 'react';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';
import { withApptRequestIvStatusDialogProvider } from '../../hooks/use-appt-request-iv-status-dialog/hoc';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';
import { ApptRequestIvStatusDialog } from '../appt-request-iv-status-dialog';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { SelfPayButton } from '../shared/self-pay-button';
import { BoldText } from '../styles';

const UnknownPatientStatusDialog: FC = () => {
  const { opened, onClose, isLoading, appointmentRequest, ivSummary } = useApptRequestIvStatusDialog();

  return (
    <ApptRequestIvStatusDialog
      opened={opened}
      title="Verification Unknown"
      subtitle={
        <>
          <BoldText>{`${appointmentRequest?.patient?.firstName} ${appointmentRequest?.patient?.lastName}`}</BoldText>
          {ivSummary?.dateReceived && <>&nbsp;- Run {moment.utc(ivSummary.dateReceived).local().format('MMM D hA')}</>}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '5px 0 20px 0', display: 'block' }}>
        {ivSummary?.ediErrorMessage ?? (
          <>
            We couldn't confirm the verification status of this patient. Please reach out to the payer directly to
            manually verify the patient or mark them as self-pay.
          </>
        )}
      </DialogSubTitle>

      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </ApptRequestIvStatusDialog>
  );
};

export default withApptRequestIvStatusDialogProvider(UnknownPatientStatusDialog);
